import React from 'react';
import { Close, CloudDownload } from '@livingdesign/icons';
import { getCsvFilename, getSelectedToFieldHeaderForCSVFile } from '../../../../../../utils/campaignEdit';
import './UploadedCSVFiles.scss';
import { IconButton } from '@livingdesign/react';

export const QA_ID_PREFIX = 'UploadedCSVFiles';

function UploadedCSVFiles({
  csvFiles = [],
  selectedCampaign,
  notificationIndex,
  loading = false,
  onDeleteFile,
  onDownloadFile,
  alertModel,
  setAlertModel,
}) {

  const formatCSVHeaderName = (selectedCampaign, notificationIndex, fileName) => {
    const headerName = getSelectedToFieldHeaderForCSVFile(selectedCampaign, notificationIndex, fileName);
    return headerName ? `[${headerName}] ` : "";
  };

  const handleDeleteClick = async () => {
    await onDeleteFile();
  };

  const handleDownloadClick = async (csvFile, index) => {
    try {
      await onDownloadFile(csvFile, index);
    } catch (error) {
      console.error('Error downloading file:', error);
      setAlertModel({
        ...alertModel,
        title: "Download Error",
        message: `Failed to download the file ${csvFile.actualFilename || csvFile.name}. Please try again.`,
        show: true,
        confirmButtonText: "OK",
        handleClose: () => setAlertModel({ ...alertModel, show: false }),
      });
    }
  };

  if (!csvFiles || csvFiles.length === 0) {
    return null;
  }

  return (
    <div 
      data-testid={`${QA_ID_PREFIX}-container`} 
      className='uploaded-csv-files-container'
    >
      <h4 
        data-testid={`${QA_ID_PREFIX}-title`}
        className='uploaded-csv-files-title'
      >
        Uploaded CSV Files
      </h4>
      <div 
        data-testid={`${QA_ID_PREFIX}-files-list`}
        className='csv-files-group'
      >
        {csvFiles.map((csvFile, index) => (
          <div 
            key={csvFile.name || index} 
            data-testid={`${QA_ID_PREFIX}-file-chip-${index}`} 
            className='csv-files-chip'
          >
            <span 
              data-testid={`${QA_ID_PREFIX}-file-name-${index}`}
              className='csv-file-name'
            >
              {formatCSVHeaderName(selectedCampaign, notificationIndex, csvFile.name)}
              {getCsvFilename(csvFile)}
            </span>
            
            <div className='csv-file-actions'>
              <IconButton
                a11yLabel='Download CSV file'
                data-testid={`${QA_ID_PREFIX}-download-button-${index}`}
                UNSAFE_className='csv-file-action-button csv-file-download'
                disabled={loading}
                onClick={() => handleDownloadClick(csvFile, index)}
                title={`Download ${csvFile.actualFilename || csvFile.name}`}
                aria-label={`Download ${csvFile.actualFilename || csvFile.name}`}
              >
                <CloudDownload size="small" />
              </IconButton>
              
              <IconButton
                a11yLabel='Delete CSV file'
                data-testid={`${QA_ID_PREFIX}-delete-button-${index}`}
                UNSAFE_className='csv-file-action-button csv-file-delete'
                disabled={loading}
                onClick={() => handleDeleteClick(csvFile, index)}
                title={`Remove ${csvFile.actualFilename || csvFile.name}`}
                aria-label={`Remove ${csvFile.actualFilename || csvFile.name}`}
              >
                <Close size="small" />
              </IconButton>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default UploadedCSVFiles;